import { render, staticRenderFns } from "./clashofwars.vue?vue&type=template&id=95b26d2a&scoped=true"
import script from "./clashofwars.vue?vue&type=script&lang=js"
export * from "./clashofwars.vue?vue&type=script&lang=js"
import style0 from "./clashofwars.vue?vue&type=style&index=0&id=95b26d2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95b26d2a",
  null
  
)

export default component.exports